import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Prio from "./pages/Prio";
import ToDoList from "./pages/ToDoList";
import Auth from "./components/Auth";
import Register from "./pages/Register";
import CalendarPage from "./pages/Calendar";
import Journals from "./pages/Journals";
import DevTelemetry from "./pages/DevTelemetry";
import Flashcards from "./pages/Flashcards";
import StudyCoach from "./pages/StudyCoach";
import "./App.css";
import { useTasks } from "./context/TaskContext";
import { isAllowedEmail } from "./config/allowedUsers";

const PrivateRoute = ({ user, children }) =>
  user && isAllowedEmail(user.email) ? children : <Navigate to="/" replace />;

function App() {
  const { user } = useTasks();
  const showDevTools =
    process.env.REACT_APP_DEV_TOOLS === "true" ||
    process.env.NODE_ENV !== "production";

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Navbar />
      <div style={{ marginTop: "0px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/ToDoList"
            element={
              <PrivateRoute user={user}>
                <ToDoList />
              </PrivateRoute>
            }
          />
          <Route
            path="/Prio"
            element={
              <PrivateRoute user={user}>
                <Prio />
              </PrivateRoute>
            }
          />
          <Route
            path="/ToDoRun"
            element={
              <PrivateRoute user={user}>
                <Navigate to="/ToDoList" replace />
              </PrivateRoute>
            }
          />
          <Route
            path="/Journals"
            element={
              <PrivateRoute user={user}>
                <Journals />
              </PrivateRoute>
            }
          />
          <Route
            path="/Calendar"
            element={
              <PrivateRoute user={user}>
                <CalendarPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/Flashcards"
            element={
              <PrivateRoute user={user}>
                <Flashcards />
              </PrivateRoute>
            }
          />
          <Route
            path="/StudyCoach"
            element={
              <PrivateRoute user={user}>
                <StudyCoach />
              </PrivateRoute>
            }
          />
          <Route path="/Register" element={<Register />} />
          <Route path="/Auth" element={<Auth />} />
          {showDevTools && (
            <Route
              path="/dev/telemetry"
              element={
                <PrivateRoute user={user}>
                  <DevTelemetry />
                </PrivateRoute>
              }
            />
          )}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
